
const AgencyInfo = props => {

  //console.log(props)
  const {
    value,
  } = props



  const organizationCode = tangibleFields.render({
    type: 'text',
    name: 'tgbl_cred_agency_organization_code',
    value: value.organization_code,
    label: 'Organization Code',
    description: 'Accrediting agencies may send a code associated with your relationship to them. You can set it here and use it on certificates or wherever you display Agency Info.',

  })

  const displayName = tangibleFields.render({
    type: 'text',
    name: 'tgbl_cred_agency_display_name',
    value: value.display_name,
    label: 'Display Name',
    description: 'Usually an acronym.',
  })

  const website = tangibleFields.render({
    type: 'text',
    name: 'tgbl_cred_agency_website',
    value: value.website,
    label: 'Website',
    description: 'This will only appear if you choose to display Agency info on your site or if you select is as a default certificate field.',
  })

  const logo = tangibleFields.render({
    type: 'gallery',
    name: 'tgbl_cred_agency_logo',
    value: value.tgbl_cred_agency_logo,
    label: 'Logo',
    description: 'This will only appear if you choose to display Agency info on your site or if you select it as a default certificate field.',
  })

  const organizationHelpText = tangibleFields.render({
    type: 'wysiwyg',
    name: 'tgbl_cred_agency_description',
    value: value.description,
    label: 'Organization Help Text',
  })

  return (
    <>
      <div className="tgbl-agency-organization_code tgbl-field-block">
        { organizationCode }
      </div>

      <div className="tgbl-agency-display-name tgbl-field-block">
        { displayName }
      </div>

      <div className="tgbl-agency-website tgbl-field-block">
        { website }
      </div>

      {/*
      <div className="tgbl-agency-logo tgbl-field-block">
        { logo }
      </div>
      */}

      <div className="tgbl-agency-description tgbl-field-block tgbl-field-wysiwyg ">
        { organizationHelpText }
      </div>

    </>
  )
}

export { AgencyInfo }
